import Actions from '../Collection/actions'

const actions = Actions.get('OFFER_');

export default actions;
